import React from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

function TermsPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: "inherit" }}>
      {/* Nav */}
      <nav className="nav">
        <div className="container">
          <div className="nav-inner">
            <div className="logo">
              <img src="/cirupay-logo-compact.svg" alt="CiruPay Logo" className="logo-image" />
            </div>
            <button className="btn" onClick={() => navigate("/")}>Back to Home</button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="container" style={{ maxWidth: "760px", padding: "3rem 1.5rem 5rem" }}>
        <h1 style={{ fontSize: "2rem", fontWeight: 700, color: "#111827", marginBottom: "0.5rem" }}>
          Terms of Service
        </h1>
        <p style={{ color: "#6b7280", marginBottom: "2.5rem" }}>Effective Date: May 21, 2026</p>

        <p style={prose}>
          Welcome to CiruPay. By accessing or using the CiruPay platform, you agree to these Terms of Service.
        </p>

        <Section title="Platform Purpose">
          <p style={prose}>
            CiruPay provides software tools that help users organize and coordinate recurring community-based
            contribution groups and payment activities.
          </p>
          <p style={prose}>CiruPay is not a bank, lender, or financial institution.</p>
        </Section>

        <Section title="Eligibility">
          <p style={prose}>
            Users must be at least 18 years old and legally authorized to use the platform.
          </p>
        </Section>

        <Section title="User Responsibilities">
          <p style={prose}>Users agree to:</p>
          <ul style={list}>
            <li>Provide accurate information</li>
            <li>Use the platform lawfully</li>
            <li>Authorize only legitimate payment methods</li>
            <li>Avoid fraudulent or abusive activity</li>
          </ul>
        </Section>

        <Section title="Payments">
          <p style={prose}>
            Payments may be processed through regulated third-party providers. Users authorize recurring
            payment activity where applicable.
          </p>
        </Section>

        <Section title="Account Suspension">
          <p style={prose}>
            CiruPay may suspend or terminate accounts engaged in suspicious, unlawful, or abusive activity.
          </p>
        </Section>

        <Section title="Limitation of Liability">
          <p style={prose}>
            CiruPay provides the platform "as is" without warranties of uninterrupted operation or guaranteed
            financial outcomes.
          </p>
        </Section>

        <Section title="Changes">
          <p style={prose}>We may update these Terms periodically.</p>
        </Section>

        <Section title="Contact">
          <p style={prose}>
            CiruPay Inc.<br />
            CiruPay Inc. — Registered in Delaware, United States.<br />
            Email: <a href="mailto:info@cirupay.com" style={{ color: "#059669" }}>info@cirupay.com</a>
          </p>
        </Section>
      </div>

      <LegalFooter navigate={navigate} />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontSize: "1.25rem", fontWeight: 600, color: "#111827", marginBottom: "0.75rem", borderBottom: "1px solid #e5e7eb", paddingBottom: "0.5rem" }}>
        {title}
      </h2>
      {children}
    </div>
  );
}

function LegalFooter({ navigate }: { navigate: (path: string) => void }) {
  return (
    <footer style={{ background: "#111827", color: "#9ca3af", padding: "2rem 1.5rem", textAlign: "center", fontSize: "0.875rem" }}>
      <p style={{ marginBottom: "0.5rem" }}>
        <button onClick={() => navigate("/privacy")} style={footerLink}>Privacy Policy</button>
        {" | "}
        <button onClick={() => navigate("/terms")} style={footerLink}>Terms of Service</button>
      </p>
      <p style={{ marginBottom: "0.5rem" }}>
        CiruPay is a financial coordination platform and is not a bank or financial institution.
      </p>
      <p>CiruPay Inc. — Registered in Delaware, United States.</p>
      <p style={{ marginTop: "0.5rem" }}>&copy; 2026 CiruPay Inc. All rights reserved.</p>
    </footer>
  );
}

const prose: React.CSSProperties = { color: "#374151", lineHeight: 1.75, marginBottom: "0.75rem" };
const list: React.CSSProperties = { color: "#374151", lineHeight: 1.75, paddingLeft: "1.5rem", marginBottom: "0.75rem" };
const footerLink: React.CSSProperties = { background: "none", border: "none", color: "#9ca3af", cursor: "pointer", textDecoration: "underline", fontSize: "0.875rem" };

export default TermsPage;
